import { bootstrapApplication } from '@angular/platform-browser';
import { App } from './app/app';
import { appConfig } from './app/app.config';
import { provideRouter } from '@angular/router';
import { routes } from './app/app.routes';
import { provideHttpClient } from '@angular/common/http';
import { ToastModule } from 'primeng/toast';
import { importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { MessageService } from 'primeng/api';
import Lara from '@primeuix/themes/lara';
import { providePrimeNG } from 'primeng/config';
import { ConfigService } from './app/services/config.service';

(async () => {
  // Load config before bootstrap
  const configService = new ConfigService();
  try {
    await configService.load();
    console.log('[Main] Config loaded:', configService);

    // Bootstrap the Angular app with the loaded config
    await bootstrapApplication(App, {
      ...appConfig,
      providers: [
        provideZoneChangeDetection(),
        { provide: ConfigService, useValue: configService },
        ...(appConfig.providers ?? []),
        provideRouter(routes),
        provideHttpClient(),
        importProvidersFrom(ToastModule),
        MessageService,
        providePrimeNG({
          theme: {
            preset: Lara
          }
        }),
      ],
    });

  } catch (err) {
    console.error('[Main] Failed to load config.json:', err);
  }
})();
